import { useContext, useState } from 'react'
import { useNavigate } from 'react-router'
import { ChevronLeft, HelpOutlineOutlined } from '@mui/icons-material'
import { Button, ButtonBase, Grid, IconButton, Typography } from '@mui/material'

import NeedHelpModal from '../../components/need-help-modal'
import DashboardScreen from '../../components/screen/dashboard-screen'
import StickyHeader from '../../components/sticky-header'
import genericAvatarImg from '../../images/generic-avatar.svg'
import alertsContactsImg from '../../images/help/alerts-contacts.svg'
import keepSensorsOnlineImg from '../../images/help/keep-sensors-online.svg'
import maintenanceTipsImg from '../../images/help/maintenance-tips.svg'
import severeWeatherPreparednessImg from '../../images/help/severe-weather-preparedness.svg'
import { DashboardContext } from '../../providers/dashboard-provider'
import { NavContext } from '../../providers/nav-provider'
import useIsMobile from '../../utils/hooks/useIsMobile'

import useStyles from './index.styles'

const Help = () => {
  const classes = useStyles
  const navigate = useNavigate()
  const isMobile = useIsMobile()
  const { setMoreMenuOpen } = useContext(NavContext)
  const { folder } = useContext(DashboardContext)

  const [helpModalOpen, setHelpModalOpen] = useState<boolean>(false)

  return (
    <DashboardScreen
      headerProps={{
        showLogo: true,
        leftIcon: isMobile ? (
          <IconButton
            size="small"
            color="secondary"
            onClick={() => {
              navigate(-1)
              setMoreMenuOpen(true)
            }}
          >
            <ChevronLeft />
          </IconButton>
        ) : undefined,
      }}
      data-testid="help-screen"
    >
      <Grid container={true} size={12} sx={classes.container}>
        {!isMobile && (
          <StickyHeader marginBottom={1}>
            <Typography variant="body2" sx={classes.desktopHeader}>
              <HelpOutlineOutlined /> Help & Support
            </Typography>
          </StickyHeader>
        )}
        <Grid container={true} size={12} sx={classes.contentContainer}>
          <Grid container={true} size={12} sx={classes.linkContainer}>
            <ButtonBase component="a" href="https://resources.meshify.com/help/#sensor-health" target="_blank" rel="noopener noreferrer">
              <Grid container={true} size={12} sx={classes.helpLinkGrid}>
                <Typography variant="body1" sx={classes.helpText}>
                  How to keep your sensors online
                </Typography>
                <Grid>
                  <img src={keepSensorsOnlineImg} alt="" width={80} height={80} />
                </Grid>
              </Grid>
            </ButtonBase>
            <ButtonBase component="a" href="https://resources.meshify.com/help/#alerts" target="_blank" rel="noopener noreferrer">
              <Grid container={true} size={12} sx={classes.helpLinkGrid}>
                <Typography variant="body1" sx={classes.helpText}>
                  All about alerts and contacts
                </Typography>
                <Grid>
                  <img src={alertsContactsImg} alt="" width={80} height={80} />
                </Grid>
              </Grid>
            </ButtonBase>
            <ButtonBase component="a" href="https://resources.meshify.com/help/#maintenance" target="_blank" rel="noopener noreferrer">
              <Grid container={true} size={12} sx={classes.helpLinkGrid}>
                <Typography variant="body1" sx={classes.helpText}>
                  Maintenance tips for success
                </Typography>
                <Grid>
                  <img src={maintenanceTipsImg} alt="" width={80} height={80} />
                </Grid>
              </Grid>
            </ButtonBase>
            <ButtonBase component="a" href="https://resources.meshify.com/help/#weather" target="_blank" rel="noopener noreferrer">
              <Grid container={true} size={12} sx={classes.helpLinkGrid}>
                <Typography variant="body1" sx={classes.helpText}>
                  Severe weather preparedness
                </Typography>
                <Grid>
                  <img src={severeWeatherPreparednessImg} alt="" width={80} height={80} />
                </Grid>
              </Grid>
            </ButtonBase>
          </Grid>
          <Grid container={true} size={12} sx={{ justifyContent: 'center', alignItems: 'center' }}>
            <Button
              variant="contained"
              size="large"
              disableElevation
              onClick={() => setHelpModalOpen(true)}
              sx={{ borderRadius: '16px' }}
              startIcon={<img src={genericAvatarImg} alt="" width={24} height={24} />}
            >
              Request Help
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <NeedHelpModal isOpen={helpModalOpen} onClose={() => setHelpModalOpen(false)} supportLevel={folder?.theme?.supportLevel as string} />
    </DashboardScreen>
  )
}

export default Help
